import axios from 'axios';
import { ApiConfig, CountryConfig, RegistrationFlowOrchestration } from '../types/apiConfig';

class ApiConfigService {
  public async getApiConfig(): Promise<ApiConfig> {
    const result = await axios.get('config.json');
    return result.data;
  }

  public async getCountryConfig(): Promise<CountryConfig[]> {
    const result = await axios.get('countryConfig.json');
    return result.data;
  }

  public async getRegistrationFlowOrchestration(): Promise<RegistrationFlowOrchestration[]> {
    const result = await axios.get('registrationFlowOrchestration.json');
    return result.data;
  }
}

export const configService = new ApiConfigService();
